module.exports = __webpack_public_path__ + "img/CM-EC-26-Mitsubishi-Modern.85b85c79.jpg";